import moment from 'moment';
import { IAdoptEaseCampaign, IAdoptEaseLocalizedText } from './AdoptEaseCampaignInterface';

export interface IAdoptEaseCampaignUser {
  enterpriseId: string;
  storeIds: string[];
  cNumbers: string[];
  roles: string[];
  permissions: string[];
}


export const getCampaignText = (text?: IAdoptEaseLocalizedText, locale?: string): string => {
  const key = (locale?.replace('_', '') || 'enUS') as keyof IAdoptEaseLocalizedText;
  return text?.[key] || text?.enUS || '';
};

const toLower = (values?: string[]) => (values ?? []).filter(Boolean).map((value) => value.toLowerCase());

const hasAny = (userValues: string[], targetValues: string[]) =>
  userValues.some((value) => targetValues.includes(value));

// (Enterprise or Store or CNumber) AND (Role or Permission)
const isUserTargeted = (campaign: IAdoptEaseCampaign, user: IAdoptEaseCampaignUser): boolean => {
  const targeting = campaign.targeting;
  const enterpriseIds = targeting?.enterpriseIds ?? [];
  const storeIds = targeting?.storeIds ?? [];
  const cNumbers = targeting?.cNumbers ?? [];
  const roles = toLower(targeting?.roles);
  const permissions = toLower(targeting?.permissions);

  const inScope = (!!user.enterpriseId && enterpriseIds.includes(user.enterpriseId))
    || hasAny(user.storeIds, storeIds)
    || hasAny(user.cNumbers, cNumbers);

  // No role or permission configured means the campaign is shown to nobody
  const hasAccess = hasAny(toLower(user.roles), roles)
    || hasAny(toLower(user.permissions), permissions);

  return inScope && hasAccess;
};

export const findAdoptEaseCampaignForApp = (
  campaigns: IAdoptEaseCampaign[],
  appId: string,
  user: IAdoptEaseCampaignUser,
): IAdoptEaseCampaign | undefined => {
  const now = moment.utc();
  return campaigns?.find((campaign) =>
    campaign.appId === appId
    && campaign.isActive
    && now.isBetween(moment.utc(campaign.startDate), moment.utc(campaign.endDate), undefined, '[]')
    && isUserTargeted(campaign, user)
  );
};
